import * as ActionTypes from '../actions/ui';
import { REHYDRATE } from 'redux-persist';
const ui = (state = { loading: false, errorMessage: null, successMessage: null }, action) => {
    switch (action.type) {         /** Message UI **/
        case REHYDRATE:
            return { ...state, errorMessage: null, successMessage: null };
        case ActionTypes.RESET_ERROR_MESSAGE:
            return { ...state, errorMessage: null };
        case ActionTypes.ADD_ERROR_MESSAGE:
            const { err = null } = action;
            let errorMessage = "Unknown error occurred.  Please try again.";
            if (err && err.message) {
                errorMessage = err.message
            } else if (err && err.error) {
                errorMessage = err.error
            } else if (err && err.errors) {
                errorMessage = err.errors;
            } else if (typeof err === 'string') {
                errorMessage = err
            }             // don't show err for session timeout 
            if (errorMessage.indexOf('There is no access token send to server') >= 0) {
                return state;
            }
            return { ...state, errorMessage };
        case ActionTypes.RESET_SUCCESS_MESSAGE:
            return { ...state, successMessage: null };
        case ActionTypes.SHOW_SUCCESS_MESSAGE:
            return { ...state, successMessage: action.message || 'Success' };          /** LOADING **/
        case ActionTypes.APP_LOADING:
            return { ...state, loading: true };
        case ActionTypes.APP_READY:
            return { ...state, loading: false };         default:
            return state;
    }
};
export default ui;
